import { useRef, useState } from 'react';
import { getTextLocalizer } from '@sas/nova-core/i18n';
import { addBundle } from '../../../../locale/createUseTextLocalizer';
import bundle from '../../NovaComponents-ColorPicker-gui-icu.properties';
addBundle(bundle);
let localize;
getTextLocalizer('NovaComponents-ColorPicker-gui-icu').then(localizer => {
  localize = localizer;
});
export const validateRGBField = params => {
  const {
    value
  } = params;
  let isError = false,
    message,
    status;
  const rgbRegex = /^([01]?[0-9]?[0-9]|2[0-4][0-9]|25[0-5])$/;
  if (value.length !== 0 && (/^\s+$/.test(value) || isNaN(parseInt(value, 10)) || !rgbRegex.test(value))) {
    isError = true;
    message = localize('customTab.rgbField.error.msg');
    status = 'alert';
  } else {
    isError = false;
    message = undefined;
    status = undefined;
  }
  return {
    isError,
    message,
    status
  };
};
export const validateHexField = params => {
  const {
    value,
    isLive
  } = params;
  let isError = false,
    message,
    status;
  if (isLive && /[^0-9a-fA-F]+/.test(value)) {
    isError = true;
    message = localize('customTab.hexField.error.msg');
    status = 'alert';
  } else if (!isLive && value.length !== 0 && !/^([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(value)) {
    isError = true;
    message = localize('customTab.hexField.error.msg');
    status = 'alert';
  } else {
    isError = false;
    message = undefined;
    status = undefined;
  }
  return {
    isError,
    message,
    status
  };
};
export const useColorValidationAdapter = props => {
  const [value, setValue] = useState(props.initialValue ?? '');
  const [error, setError] = useState({
    isError: false,
    message: undefined,
    status: undefined
  });
  const preservedValue = useRef(value);
  const adapterType = useRef(props.adapterType ?? 'RGB');
  const handleChange = event => {
    setValue(event.value);
    const errors = props.validateInputFunction?.({
      value: event.value,
      isLive: true
    });
    setError(errors ?? {
      isError: false,
      message: undefined,
      status: undefined
    });
  };
  const handleBlur = () => {
    let formattedValue;
    if (adapterType.current === 'RGB') {
      if (error.isError) return;
      if (value.length === 0) {
        formattedValue = preservedValue.current;
      } else {
        formattedValue = parseInt(value, 10).toString();
      }
      props.onCommit?.(formattedValue);
      preservedValue.current = formattedValue;
      setValue(formattedValue);
    }
    if (adapterType.current === 'HEX') {
      if (error.isError) return;
      const errorOnBlur = props.validateInputFunction?.({
        value,
        isLive: false
      });
      if (errorOnBlur?.isError) {
        setError(errorOnBlur);
        return;
      }
      if (value.length === 0) {
        formattedValue = preservedValue.current;
      } else if (value.length === 3) {
        formattedValue = [...value].reduce((acc, char) => acc + char.repeat(2), '').toUpperCase();
        preservedValue.current = formattedValue;
      } else if (value !== preservedValue.current) {
        formattedValue = value.toUpperCase();
        preservedValue.current = formattedValue;
      } else {
        return;
      }
      setValue(formattedValue);
      props.onCommit?.(formattedValue);
    }
  };
  const handleCommit = e => {
    if (e.reason === 'blur') return;
    let formattedValue;
    if (adapterType.current === 'RGB') {
      if (value.length === 0 || error.isError) return;
      formattedValue = parseInt(value, 10).toString();
      setValue(formattedValue);
      props.onCommit?.(formattedValue);
      preservedValue.current = formattedValue;
    }
    if (adapterType.current === 'HEX') {
      if (value.length === 0 || error.isError) return;
      const errorOnCommit = props.validateInputFunction?.({
        value,
        isLive: false
      });
      if (errorOnCommit?.isError) {
        setError(errorOnCommit);
        return;
      }
      if (value.length === 3) {
        formattedValue = [...value].reduce((acc, char) => acc + char.repeat(2), '').toUpperCase();
      } else if (value !== preservedValue.current) {
        formattedValue = value.toUpperCase();
      } else {
        return;
      }
      preservedValue.current = formattedValue;
      setValue(formattedValue);
      props.onCommit?.(formattedValue);
    }
  };
  const handleCancel = () => {
    let formattedValue;
    if (adapterType.current === 'RGB') {
      if (value === preservedValue.current) return false;
      if (value.length === 0 || error.isError || value !== preservedValue.current) {
        formattedValue = parseInt(preservedValue.current, 10).toString();
        setValue(formattedValue);
        error.isError && setError({
          isError: false,
          message: undefined,
          status: undefined
        });
        return true;
      }
    }
    if (adapterType.current === 'HEX') {
      if (value === preservedValue.current) return false;
      if (error.isError || value.length === 0 || value !== preservedValue.current) {
        setValue(preservedValue.current);
        error.isError && setError({
          isError: false,
          message: undefined,
          status: undefined
        });
        return true;
      }
    }
  };
  return {
    value,
    error,
    setValue,
    setError,
    preservedValue,
    handleChange,
    handleBlur,
    handleCommit,
    handleCancel
  };
};
//# sourceMappingURL=useColorValidationAdapter.js.map